import Vue from 'vue';
import router from './router';
import App from './App.vue';
import { Message } from 'view-design';
import './theme/index.less';
import './assets/styles/global.scss';
import './assets/styles/modal.scss';
import 'view-design/dist/styles/iview.css';
import CGI from './CGI';

Vue.use(CGI);
Vue.config.productionTip = false;
Vue.prototype.$Message = Message;

export default new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
